import React from 'react';

const FakePage = () => {
  return <div>Pagina não encontrada</div>;
};

export default FakePage;
